import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import RefreshIcon from '@mui/icons-material/Refresh'
import { styled, Theme } from '@mui/material/styles'
import { FC, ReactElement } from 'react'
import { FieldProps, useRecordContext } from 'react-admin'
import { border, xxllncColor } from '../../layout/themes'

interface StatusChipFieldProps extends FieldProps {
  addLabel?: boolean
}

export const StatusChipField: FC<StatusChipFieldProps> = ({ addLabel = true, ...props }) => {
  const record = useRecordContext(props)
  const styleProps: StyleProps = {
    changeType: record?.changeType as string,
  }

  const GetIcon = (): ReactElement => {
    switch (record?.changeType) {
      case 'update':
        return <RefreshIcon className={classes.icon} />
      case 'insert':
        return <AddOutlinedIcon className={classes.icon} />
      case 'delete':
        return <DeleteOutlinedIcon className={classes.icon} />
      default:
        return <></>
    }
  }

  return (
    <Root className={classes.root} {...styleProps}>
      <GetIcon />
    </Root>
  )
}

interface StyleProps {
  changeType?: string
}

const PREFIX = 'xxllncStatusChipField'

const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
}

const Root = styled('div', {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme, changeType }: StyleProps & { theme?: Theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.icon}`]: {
    backgroundColor: changeType === 'delete'
      ? xxllncColor.opRed10 : changeType === 'update'
        ? xxllncColor.opBlue10 : xxllncColor.opGreen10,
    height: 24,
    width: 24,
    color: changeType === 'delete'
      ? xxllncColor.red100 : changeType === 'update'
        ? xxllncColor.blue100 : xxllncColor.green100,
    padding: 4,
    boxSizing: 'border-box',
    borderRadius: border.radius.lg,
  },
}))